export default {
  organizationLabel: {
    width:235, 
    float:'left', 
    textAlign: 'right', 
    paddingRight: 10
  },

  organizationInputs: {
    width: 500, 
    float:'left'
  },

  textArea: {
    height: 'calc(100vh - 270px)',
    maxWidth: 1100
  },

  toolbar: {
    position:'fixed', 
    right: 30,
    top: 130,
    zIndex: 1000
  },

  tableIcon: { 
    fontSize: 22, 
    color: '#666', 
    marginLeft: 10 
  }
}


// WEBPACK FOOTER //
// ./src/sbt/sbt.css.js